<template>
  <div v-if="$attrs.isLoading">
    <v-skeleton-loader type="text" width="25%"> </v-skeleton-loader>
    <v-skeleton-loader class="d-flex" type="text@5"> </v-skeleton-loader>
  </div>
  <div v-else>
    <v-autocomplete
      autocomplete="off"
      :rules="rules"
      v-bind="$attrs"
      :disabled="getIrisRdonlyMode"
      :filled="getIrisRdonlyMode"
      :class="[getIrisCssClass,getTextTransform]"
      clearable
      :loading="loading"
      :search-input.sync="search"
      v-model="Value"
    >
      <template v-slot:selection="{ item, parent }">
        <v-tooltip bottom open-delay="500">
          <template v-slot:activator="{ on, attrs }">
            <v-chip         
            :input-value="item.selected"
            v-bind="attrs"
            v-on="on"
            >
              <span class="text-truncate">{{ getCatLabel(item) }}</span>
              <v-icon color="grey darken-1" v-if="!getIrisRdonlyMode" right @click="remove(item, parent)" size="20">mdi-close-circle</v-icon>
            </v-chip>
          </template>
          {{getCatLabel(item)}}
        </v-tooltip>
      </template>
      <template v-if="getTextTransform !== ''" v-slot:item="{item,parent,attrs}">
          <v-checkbox v-if="isMultiple" :hide-details="true" 
            :input-value="attrs.inputValue" 
            :class="[getTextTransform,'custom-input ma-0 pa-0']" 
            :label="getCatLabel(item)">
            <template v-slot:label>
              <span :class="getTextTransform" v-html="parent.genFilteredText(getCatLabel(item))"></span>
            </template>
          </v-checkbox>
          <span v-else :class="getTextTransform" v-html="parent.genFilteredText(getCatLabel(item))"></span>
      </template>
      <template v-slot:label  v-if="fldRequiredVal"> {{ $attrs.label }} <span class="red--text">*</span> </template>
      <template v-slot:append-outer v-if="tooltip">
        <edn-tooltip> {{ tooltip }}</edn-tooltip>
      </template>
      <template v-slot:append v-if="getIrisRdonlyMode">
        <v-icon class="v-icon--disabled">mdi-menu-down</v-icon>
        <v-icon class="v-icon--disabled">mdi-lock</v-icon>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { ednRequired } from './mixins/ednRequired'
import { ednMimicMix } from './mixins/ednMimicMix'
import ednTooltip from './ednTooltip'
import { ednTransform } from './mixins/ednTransform'
import { ednValue } from './mixins/ednValue'

export default {
  mixins: [ednRequired, ednMimicMix,ednTransform, ednValue],
  components: {
    ednTooltip,
  },
  inheritAttrs: false,
  data() {
    return {
      search: null,
    }
  },
  props: {
    tooltip: String,
    loading: {
      type: Boolean,
      default: false
    },
    value: null,
  },
  computed: {
    /** Couleur de la chips */
    getIrisChipColor() {
      return this.getIrisRdonlyMode ? 'grey lighten-2' : this.getIrisMode ? 'grey lighten-3' : ''
    },
    /** Couleur du texte des chips */
    getIrisChipTxtColor() {
      return this.getIrisRdonlyMode ? 'grey darken-2' : this.getIrisMode ? 'grey darken-3' : ''
    },
  },
  watch: {
    search (val) {
      val && val !== this.select && this.querySelections(val)
    }
  },
  methods: {
    /** Enlève la valeur si on coche la croix, appelle des méthodes vuetify */
    remove(item,parent) {
      if(!parent) return

      if (this.isMultiple) parent.selectItem(item);
      else parent.setValue(null)

    },
    getCatLabel(data){
      if(typeof data === "object")
        return data.text
      else
        return data
    },
    querySelections (val) {
      this.$emit("update:searchInput", val);
    },
  }
}
</script>
<style lang='scss' scoped>
.v-input {
  &.iris-mimic {
    .v-label {
      &.v-label--active {
        line-height: 5px;
        overflow: visible;
      }
    }
  }
}
.iris-rdonly::v-deep  .v-label{
  top: 12px;
}
</style>
